import _inject from "@stylexjs/stylex/lib/stylex-inject";
var _inject2 = _inject;
import type { LucideIcon } from "lucide-react";
import * as stylex from "@stylexjs/stylex";
import { Link, type LinkProps } from "@tanstack/react-router";
import { BorderBeam } from "../custom/border-beam";
import { MagicCard } from "../custom/magic-card";
_inject2({
  ltr: ".x17vydhw{--dashboard-link-icon-scale:1}",
  priority: 1
});
_inject2({
  ltr: ".x17j1u41:hover{--dashboard-link-icon-scale:1.05}",
  priority: 131
});
_inject2({
  ltr: ".x1lliihq{display:block}",
  priority: 3000
});
_inject2({
  ltr: ".x5yr21d{height:100%}",
  priority: 4000
});
_inject2({
  ltr: ".x8jt5ee{border-radius:1.25rem}",
  priority: 2000
});
_inject2({
  ltr: ".xdpxx8g{text-align:left}",
  priority: 3000
});
_inject2({
  ltr: ".xeaf4i8{white-space:normal}",
  priority: 3000
});
_inject2({
  ltr: ".x1a2a7pz{outline:none}",
  priority: 2000
});
_inject2({
  ltr: ".x1v7yk1c:focus-visible{box-shadow:0 0 0 3px color-mix(in oklab,var(--ring) 50%,transparent)}",
  priority: 3040
});
_inject2({
  ltr: ".x1n2onr6{position:relative}",
  priority: 3000
});
_inject2({
  ltr: ".x78zum5{display:flex}",
  priority: 3000
});
_inject2({
  ltr: ".xqvtoxn{min-height:14.5rem}",
  priority: 4000
});
_inject2({
  ltr: ".xdt5ytf{flex-direction:column}",
  priority: 3000
});
_inject2({
  ltr: ".x1cy8zhl{align-items:flex-start}",
  priority: 3000
});
_inject2({
  ltr: ".xxhr3t{gap:0}",
  priority: 2000
});
_inject2({
  ltr: ".xmkeg23{border-width:1px}",
  priority: 2000
});
_inject2({
  ltr: ".x1y0btm7{border-style:solid}",
  priority: 2000
});
_inject2({
  ltr: ".x18e8jsu{border-color:color-mix(in oklab,var(--primary) 14%,transparent)}",
  priority: 2000
});
_inject2({
  ltr: ".x12mez3o:hover{border-color:color-mix(in oklab,var(--primary) 30%,transparent)}",
  priority: 2130
});
_inject2({
  ltr: ".x15qofif{background-image:linear-gradient(160deg,color-mix(in oklch,var(--card) 96%,var(--secondary) 4%),color-mix(in oklch,var(--card) 90%,var(--accent) 10%))}",
  priority: 3000
});
_inject2({
  ltr: ".x6ly6sf:hover{background-image:linear-gradient(160deg,color-mix(in oklch,var(--card) 93%,var(--secondary) 7%),color-mix(in oklch,var(--card) 86%,var(--accent) 14%))}",
  priority: 3130
});
_inject2({
  ltr: ".x1uz70x1{padding:1rem}",
  priority: 1000
});
_inject2({
  ltr: ".x11jfisy{color:var(--foreground)}",
  priority: 3000
});
_inject2({
  ltr: ".x16c7o0m{box-shadow:inset 0 1px 0 color-mix(in oklch,var(--foreground) 12%,transparent)}",
  priority: 3000
});
_inject2({
  ltr: ".x799pyu:hover{box-shadow:0 12px 20px -18px color-mix(in oklch,var(--primary) 45%,transparent)}",
  priority: 3130
});
_inject2({
  ltr: ".x7qrkjq{transition-property:border-color,box-shadow,background}",
  priority: 3000
});
_inject2({
  ltr: ".x13dflua{transition-duration:.2s}",
  priority: 3000
});
_inject2({
  ltr: ".xluow7k{border-color:color-mix(in oklab,var(--primary) 35%,transparent)}",
  priority: 2000
});
_inject2({
  ltr: ".x1n327nk{z-index:10}",
  priority: 3000
});
_inject2({
  ltr: ".x1gr9t9r{margin-bottom:.75rem}",
  priority: 4000
});
_inject2({
  ltr: ".xvm51jw{width:2.5rem}",
  priority: 4000
});
_inject2({
  ltr: ".xwaiz5r{height:2.5rem}",
  priority: 4000
});
_inject2({
  ltr: ".x6s0dn4{align-items:center}",
  priority: 3000
});
_inject2({
  ltr: ".xl56j7k{justify-content:center}",
  priority: 3000
});
_inject2({
  ltr: ".x10hpsqq{border-radius:9999px}",
  priority: 2000
});
_inject2({
  ltr: ".xeu4j9f{background-color:color-mix(in oklab,var(--card) 80%,transparent)}",
  priority: 3000
});
_inject2({
  ltr: ".xzwifym{color:var(--primary)}",
  priority: 3000
});
_inject2({
  ltr: ".x1bbn379{box-shadow:0 1px 3px 0 rgb(0 0 0 / .1),0 1px 2px -1px rgb(0 0 0 / .1)}",
  priority: 3000
});
_inject2({
  ltr: ".xqlnqd4{transform:scale(var(--dashboard-link-icon-scale))}",
  priority: 3000
});
_inject2({
  ltr: ".x11xpdln{transition-property:transform}",
  priority: 3000
});
_inject2({
  ltr: ".xsk17dz{width:1.125rem}",
  priority: 4000
});
_inject2({
  ltr: ".xaylbqo{height:1.125rem}",
  priority: 4000
});
_inject2({
  ltr: ".xb3r6kr{overflow:hidden}",
  priority: 2000
});
_inject2({
  ltr: ".xlyipyv{text-overflow:ellipsis}",
  priority: 3000
});
_inject2({
  ltr: ".xuxw1ft{white-space:nowrap}",
  priority: 3000
});
_inject2({
  ltr: ".x1jchvi3{font-size:1rem}",
  priority: 3000
});
_inject2({
  ltr: ".x17mssa0{line-height:1.5rem}",
  priority: 3000
});
_inject2({
  ltr: ".x1s688f{font-weight:600}",
  priority: 3000
});
_inject2({
  ltr: ".x1tbvfm1{margin-top:.25rem}",
  priority: 4000
});
_inject2({
  ltr: ".x104kibb{display:-webkit-box}",
  priority: 3000
});
_inject2({
  ltr: ".x1ua5tub{-webkit-box-orient:vertical}",
  priority: 3000
});
_inject2({
  ltr: ".x1s7n7y8{-webkit-line-clamp:5}",
  priority: 3000
});
_inject2({
  ltr: ".xkpwil5{font-size:.875rem}",
  priority: 3000
});
_inject2({
  ltr: ".xrvchh{color:var(--muted-foreground)}",
  priority: 3000
});
_inject2({
  ltr: ".xhj8ucd{margin-top:.75rem}",
  priority: 4000
});
_inject2({
  ltr: ".x3nfvp2{display:inline-flex}",
  priority: 3000
});
_inject2({
  ltr: ".x1kd7e19{border-color:color-mix(in oklab,var(--primary) 25%,transparent)}",
  priority: 2000
});
_inject2({
  ltr: ".x1qa3ccr{background-color:color-mix(in oklab,var(--card) 60%,transparent)}",
  priority: 3000
});
_inject2({
  ltr: ".xvpgqt4{padding-inline:.625rem}",
  priority: 2000
});
_inject2({
  ltr: ".x1o5vn8x{padding-block:.25rem}",
  priority: 2000
});
_inject2({
  ltr: ".x1ll8agd{font-size:.66rem}",
  priority: 3000
});
_inject2({
  ltr: ".x7447wj{letter-spacing:.12em}",
  priority: 3000
});
_inject2({
  ltr: ".xtvhhri{text-transform:uppercase}",
  priority: 3000
});
_inject2({
  ltr: ".x1h2fgio{color:color-mix(in oklab,var(--primary) 90%,transparent)}",
  priority: 3000
});
const styles = {
  card: {
    kVAEAm: "x1n2onr6",
    k1xSpc: "x78zum5",
    kZKoxP: "x5yr21d",
    kAzted: "xqvtoxn",
    kXwgrk: "xdt5ytf",
    kGNEyG: "x1cy8zhl",
    kOIVth: "xxhr3t",
    kaIpWk: "x8jt5ee",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x18e8jsu x12mez3o",
    kKwaWg: "x15qofif x6ly6sf",
    kmVPX3: "x1uz70x1",
    k9WMMc: "xdpxx8g",
    kMwMTN: "x11jfisy",
    kGVxlE: "x16c7o0m x799pyu",
    k1ekBW: "x7qrkjq",
    kIyJzY: "x13dflua",
    $$css: true
  },
  featuredCard: {
    kVAM5u: "xluow7k x12mez3o",
    $$css: true
  }
};
export interface LinkCardProps {
  title: string;
  description: string;
  to: LinkProps["to"];
  icon?: LucideIcon;
  featured?: boolean;
}
export const LinkCard = ({
  description,
  title,
  to,
  icon: Icon,
  featured = false
}: LinkCardProps) => {
  return <Link to={to} className="x17vydhw x17j1u41 x1lliihq x5yr21d x8jt5ee xdpxx8g xeaf4i8 x1a2a7pz x1v7yk1c">
      <MagicCard mode="gradient" gradientColor="rgba(255, 255, 255, 0.2)" gradientOpacity={0.75} gradientFrom="#f2b66d" gradientTo="#6cbec6" decoration={featured ? <BorderBeam size={86} duration={7} borderWidth={1.5} colorFrom="#f2b66d" colorTo="#6cbec6" /> : null} stylexStyle={[styles.card, featured && styles.featuredCard]}>
        <div className="x1n2onr6 x1n327nk">
          {Icon ? <div className="x1gr9t9r x78zum5 xvm51jw xwaiz5r x6s0dn4 xl56j7k x10hpsqq xeu4j9f xzwifym x1bbn379 xqlnqd4 x11xpdln x13dflua">
              <Icon className="xsk17dz xaylbqo" strokeWidth={2.1} />
            </div> : null}
          <div className="xb3r6kr xlyipyv xuxw1ft x1jchvi3 x17mssa0 x1s688f xzwifym">{title}</div>
          <div className="x1tbvfm1 x104kibb xb3r6kr x1ua5tub x1s7n7y8 xkpwil5 x17mssa0 xrvchh">{description}</div>
          {featured ? <div className="xhj8ucd x3nfvp2 x6s0dn4 x10hpsqq xmkeg23 x1y0btm7 x1kd7e19 x1qa3ccr xvpgqt4 x1o5vn8x x1ll8agd x1s688f x7447wj xtvhhri x1h2fgio">Featured</div> : null}
        </div>
      </MagicCard>
    </Link>;
};